import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpTestDataResultFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpTestDataResult
 */

export class ExpTestDataResultFactory {}
_ExpTestDataResultFactory = ExpTestDataResultFactory;
_defineProperty(ExpTestDataResultFactory, "FromJSON", function (json) {
  return _ExpTestDataResultFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpTestDataResultFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'nodeID': json['nodeID'],
    'value': json['value'],
    'integrationConfiguration': json['integrationConfiguration'] === null || json['integrationConfiguration'] === undefined ? json['integrationConfiguration'] : json['integrationConfiguration']
  };
});
_defineProperty(ExpTestDataResultFactory, "ToJSON", function (value) {
  return _ExpTestDataResultFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpTestDataResultFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'nodeID': value.nodeID,
    'value': value.value,
    'integrationConfiguration': value.integrationConfiguration
  };
});
//# sourceMappingURL=ExpTestDataResult.js.map
